import React from "react";
import { useSeriesShowContext } from "../SeriesShowApp";
import { formatWholeCents } from "../../../shared/teamCurrencyFormatting";

const daysFromNow = (iso) => {
  const ms = new Date(iso) - new Date();
  return Math.max(0, Math.round(ms / 86400000));
};

const NextEventCard = () => {
  const { series } = useSeriesShowContext();
  const event = series.next_event;
  const days = daysFromNow(event.start_time);
  const datePart = new Date(event.start_time).toLocaleDateString("en-US", {
    weekday: "short", month: "short", day: "numeric", year: "numeric",
  });
  const timePart = new Date(event.start_time).toLocaleTimeString("en-US", {
    hour: "numeric", minute: "2-digit",
  });
  const soldOut = event.capacity > 0 && event.tickets_sold >= event.capacity;

  return (
    <a href={event.show_url} className="d-flex align-items-center series-next-card">
      <div className="d-flex align-items-center justify-content-center series-next-icon">
        <i className="fa fa-clock series-next-icon-glyph" />
      </div>

      <div className="flex-grow-1">
        <div className="series-next-eyebrow">
          Next event &middot; in {days} {days === 1 ? "day" : "days"}
        </div>
        <div className="series-next-datetime">
          {datePart} &middot; {timePart}
        </div>
        <div className="series-next-stats">
          <strong>{event.tickets_sold} / {event.capacity}</strong> tickets sold
          {soldOut && " (sold out)"}
          {" · "}
          <strong>{formatWholeCents(event.gross_cents, series.base_currency_symbol)}</strong> gross
        </div>
      </div>

      <div className="series-next-cta-wrap">
        <span className="d-inline-flex align-items-center series-next-cta">
          View event
          <i className="fa fa-arrow-right series-next-cta-arrow" />
        </span>
      </div>
    </a>
  );
};

export default NextEventCard;
